import React, { useState} from 'react';
import logo from './assets/bennisbar_logo.png';
import insta_bw from './assets/Instagram_Glyph_Black.svg';
import insta_gradient from './assets/Instagram_Glyph_Gradient.svg';
import './App.css';
import {
    Avatar,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    Typography,
} from "@material-ui/core";
import {Close, Email, Phone} from "@material-ui/icons";
import Datenschutz from "./components/Datenschutz";
import Impressum from "./components/Impressum";
import {IFile} from "./utils/drive.api.utils";

const App = () => {
    const [imprintOpen, setImprintOpen] = useState(false);
    const [privacyOpen, setPrivacyOpen] = useState(false);
    const [holidayInfoOpen, setHolidayInfoOpen] = useState(false);

    const [isHover, setIsHover] = useState(false);

    return (
        <div className="App">
            <Box
                width={400}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                flexDirection={'column'}
                textAlign={'center'}
            >
                <Box position={'relative'}>
                    <Avatar variant={"circular"} src={logo} className="logo" alt="Café Bellini Freising"/>
                </Box>
                <div className={'bottom'}>
                    {/*<p className={'slogan'}>*/}
                    {/*    Café Bellini Freising*/}
                    {/*</p>*/}
                    <address className={'address'}>
                        <br/>
                        Untere Hauptstraße 31<br/>
                        85354 Freising<br/>
                        <br/>
                        <a href={'tel:+4981619102651'} title={"Nummer anrufen"}><Phone className={'whatsappIcon'}/> +49
                            (0)8161 9102651</a><br/>
                        <a href={'mailto:salisch.gastro@gmail.com'} title={"E-Mail schreiben"}><Email
                            className={'whatsappIcon'}/> salisch.gastro@gmail.com</a><br/>
                    </address>
                    <Box pt={4}>
                        <Typography variant={"subtitle1"}>Öffnungszeiten:</Typography>
                        <Typography variant={"body2"}>
                            <br/>
                            Mo - Mi von 09:00 – 18:00<br/>
                            Do - Sa von 09:00 – 24:00<br/>
                            Sonntag von 13:00 – 18:00
                        </Typography>
                    </Box>
                    <Box mt={4} display={'flex'} justifyContent={'center'} flexDirection={'column'}>
                        <Box mb={3} style={{display: 'flex', justifyContent: 'center'}}>
                                <a href="https://www.instagram.com/bennis_bar_fs"
                                   target={"_blank"} title={"Besuche Benni's Bar auf Instagram"}
                                   onMouseEnter={() => setIsHover(true)}
                                   onMouseLeave={() => setIsHover(false)}
                                >
                                    <img src={insta_gradient} alt={"Instagram Logo"} width={24} style={{display: isHover ? 'block': 'none'}}/>
                                    <img src={insta_bw} alt={"Instagram Logo"} width={24} style={{display: !isHover ? 'block': 'none'}}/>
                                </a>
                        </Box>
                    </Box>
                </div>
            </Box>

            <Box className={'impressumsLink'} display={'flex'}>
                <Button onClick={() => setImprintOpen(true)} variant={"text"}>
                    Impressum
                </Button>
                <Button onClick={() => setPrivacyOpen(true)} variant={"text"}>
                    Datenschutz
                </Button>
            </Box>

            {/*<Dialog open={eventOpen} onClose={() => setEventOpen(false)} className={'dialog'}>*/}
            {/*    <IconButton onClick={() => setEventOpen(false)} className={'dialogClose'}>*/}
            {/*        <Close/>*/}
            {/*    </IconButton>*/}
            {/*    <DialogContent>*/}
            {/*        <img src={eventcalendar} alt={"Veranstaltungen im Juli"} className={"eventImage"}/>*/}
            {/*    </DialogContent>*/}
            {/*    <DialogActions>*/}
            {/*        <Button*/}
            {/*            startIcon={<WhatsApp/>}*/}
            {/*            onClick={handleWhatsAppClick}*/}
            {/*        >*/}
            {/*            schreib uns*/}
            {/*        </Button>*/}
            {/*    </DialogActions>*/}
            {/*</Dialog>*/}

            <Dialog open={imprintOpen} onClose={() => setImprintOpen(false)} className={'dialog'}>
                <IconButton onClick={() => setImprintOpen(false)} className={'dialogClose'}>
                    <Close/>
                </IconButton>
                <Impressum/>
                <DialogActions>
                    <Button onClick={() => setImprintOpen(false)}>
                        schließen
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={privacyOpen} onClose={() => setPrivacyOpen(false)} className={'dialog'}>
                <IconButton onClick={() => setPrivacyOpen(false)} className={'dialogClose'}>
                    <Close/>
                </IconButton>
                <Datenschutz/>
                <DialogActions>
                    <Button onClick={() => setPrivacyOpen(false)}>
                        schließen
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={holidayInfoOpen} onClose={() => setHolidayInfoOpen(false)} className={'dialog'}>
                <IconButton onClick={() => setHolidayInfoOpen(false)} className={'dialogClose'}>
                    <Close/>
                </IconButton>
                <DialogContent>
                    <Box mt={5}>
                        <Typography variant={"body2"} gutterBottom>
                            Das Salisch hat bis zum 16 Januar Betriebsurlaub.
                        </Typography>
                        <Typography variant={"body2"} gutterBottom>
                            Wir freuen uns auf Euch im neuen Jahr!
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setHolidayInfoOpen(false)}>
                        ok
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    );
}

export default App;
